import { useEffect, useState } from "react";

const logoSrc = `${process.env.PUBLIC_URL || ""}/ZAKI-logo.png`;

const Mark = () => (
  <img className="brand-logo" src={logoSrc} alt="Zaki Creative Studio" />
);

const Navbar = () => {
  const getHashPath = () => {
    const rawHash = window.location.hash.replace(/^#/, "");
    const normalized = rawHash === "" || rawHash === "/" ? "/" : rawHash;
    return normalized.startsWith("/") ? normalized : `/${normalized}`;
  };

  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [path, setPath] = useState(getHashPath());

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onHashChange = () => setPath(getHashPath());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    setScrolled(false);
  }, [path]);

  const close = () => setOpen(false);

  const setHash = (to) => {
    const hashToSet = to === "/" ? "#/" : `#${to}`;
    if (window.location.hash !== hashToSet) {
      window.location.hash = hashToSet;
    }
  };

  const navigate = (to) => {
    setHash(to);
    if (to === "/" || to === "/work") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setScrolled(false);
    }
    close();
  };

  const isWorkPage = path.startsWith("/work");

  return (
    <header className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      <a
        className="brand"
        href={isWorkPage ? "#/" : "#home"}
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        }}
      >
        <Mark />
      </a>
      <button
        className="menu-toggle"
        type="button"
        aria-expanded={open}
        aria-controls="primary-navigation"
        aria-label="Toggle navigation"
        onClick={() => setOpen((value) => !value)}
      >
        <span />
        <span />
      </button>
      <nav
        id="primary-navigation"
        className={`primary-nav ${open ? "is-open" : ""}`}
      >
        {isWorkPage ? (
          <>
            <a
              href="#/"
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
            >
              Home
            </a>
            {/* <a href="#/work?section=branding" onClick={close}>
              Branding
            </a> */}
            <a href="#/work?section=motion" onClick={close}>
              Motion Projects
            </a>
              {/* <a href="#/work?section=partners" onClick={close}>
              Partners
            </a> */}
          </>
        ) : (
          <>
            <a href="#about" onClick={close}>
              About
            </a>
            <a href="#what-we-do-id" onClick={close}>
              What we do
            </a>
            <a
              href="#/work"
              onClick={(e) => {
                e.preventDefault();
                navigate("/work");
              }}
            >
              Our Work
            </a>
            <a href="#service-01" onClick={close}>
              Services
            </a>
            <a className="nav-cta" href="#contact" onClick={close}>
              Start a project <span aria-hidden="true">↗</span>
            </a>
          </>
        )}
      </nav>
    </header>
  );
};

export { Mark };
export default Navbar;
